import * as amplitude from '@amplitude/analytics-browser'

export const amplitudeInstance = amplitude.createInstance()
amplitudeInstance.init('22f4c6e97adb3c0d863b5a8ffbb9465e', {
  autocapture: { elementInteractions: true },
})
